import { render, staticRenderFns } from "./SubStatus.vue?vue&type=template&id=368d7f4c&"
import script from "./SubStatus.vue?vue&type=script&lang=ts&"
export * from "./SubStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SubStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports